import { render, staticRenderFns } from "./CompareSpecsComponent.vue?vue&type=template&id=3fafdb5f"
import script from "./CompareSpecsComponent.vue?vue&type=script&lang=js"
export * from "./CompareSpecsComponent.vue?vue&type=script&lang=js"
import style0 from "./CompareSpecsComponent.vue?vue&type=style&index=0&id=3fafdb5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports